<template>
  <div v-bind:value="value">
    <b-modal @show="limpiarOtro" v-model="getOtros" no-close-on-backdrop no-close-on-esc>
      <template #modal-header>Agregar Otros Contenidos </template>
      <label for="oc">Tipo de contenido</label>
      <b-form-select id="oc" class="w-100 my-2" v-model="Otro.Tipo" :options="OtrosContenidos"></b-form-select>

      <b-form-textarea v-model="Otro.Contenido" autofocus placeholder="Descripción del contenido" rows="3" max-rows="6"></b-form-textarea>

      <b-form-group :description="Conversion(Otro.Cobro)">
        <b-input-group prepend="Cobro" class="my-2">
          <b-form-input v-model="Otro.Cobro" type="number"></b-form-input>
        </b-input-group>
      </b-form-group>

      <template #modal-footer>
        <b-button @click="getOtros = false">Cerrar</b-button>
        <b-button :disabled="!guardarOtro" variant="success" @click="AgregaOtro">Guardar</b-button>
      </template>
    </b-modal>

    <addPak @onAgregaPaquete="AgregarPaquete" :ver="verAddPak" :precio="Precio"></addPak>
    <b-card class="my-2">
      <b-row>
        <b-col>
          <h5>Contenido:</h5>
        </b-col>
        <b-col class="gradiente text-center p-1">
          <b-button pill size="sm" variant="success" class="m-1" @click="verAddPak = true">
            <b-icon-archive />
          </b-button>
          <b-button pill size="sm" variant="success" class="m-1" @click="getOtros = !getOtros">
            <b-icon-basket />
          </b-button>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-table @row-clicked="onRowClick" v-show="value.length > 0" head-variant="dark" hover bordered table-variant="warning" small :items="tblContenido" :fields="camposContenido"></b-table>

        <b-alert variant="success" :show="value.length == 0"> <b-icon-exclamation-circle-fill /> No hay contenido! </b-alert>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import addPak from "./addPak.vue";



let Unir = function(v) {
  let dato = v.map((cont) => {
    return cont.Cantidad + " " + cont.Producto;
  });
  return dato.join();
};

export default {
  components: { addPak },
  computed: {
    guardarOtro() {
      let o = this.Otro;
      return o.Contenido != "" && o.Cobro != "";
    },
    tblContenido() {
      let datos = this.value.map((dato) => {
        return {
          Tipo: dato.Tipo,
          Peso: dato.Peso,
          Contenido: Unir(dato.Contenido),
          Cobro: dato.Cobro || 0.0,
        };
      });
      return datos;
    },
  },
  methods: {
    AgregaOtro() {
      let otro = { ...this.Otro };
      let c = [];

      c.push({ Cantidad: "", Producto: this.Otro.Contenido });
      otro.Peso = "0.0";
      otro.Contenido = c;
      this.value.push(otro);
      this.getOtros = false;
    },
    Conversion(dolares) {
      if (dolares > 0) return "Quetzales: " + (dolares * this.tipoCambio).toFixed(2);
      else "";
    },
    limpiarOtro() {
      this.Otro = { Tipo: "Otros", Contenido: "", Cobro: "" };
    },
    ConfirmaEliminar(fn) {
      this.$bvModal
        .msgBoxConfirm("Desea elimininar el contenido?", {
          title: "Confirmación",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Si",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((rs) => {
          console.log(rs);
          if (rs) fn();
        });
    },

    AgregarPaquete(v) {
      if (v.Contenido.length > 0) {
        this.value.push(v);
        localStorage.removeItem("Pak");
      }
      this.verAddPak = false;
    },
    onRowClick() {
      this.ConfirmaEliminar(() => {
        let id = arguments[1];
        this.value.splice(id, 1);
      });
    },
  },
  mounted() {
    var fecha = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    fecha.setDate(fecha.getDate() - 1);

    let viajes = JSON.parse(localStorage.Viajes);
    viajes = viajes.filter((v) => new Date(v.fecha) > fecha);

    this.Precio = viajes[0].precio;
  },
  data() {
    return {
      getOtros: false,
      OtrosContenidos: ["Otros", "Medicamento", "Documento"],
      Otro: { Tipo: "Otros", Contenido: "", Cobro: "" },
      Precio: null,
      verAddPak: false,
      camposContenido: [{ key: "Tipo", label: "Tipo", width: 30 }, "Peso", "Cobro", "Contenido"],
    };
  },
  props: ["value","tipoCambio"],
};
</script>
<style scoped>
.gradiente {
  background-image: linear-gradient(to right, white, #e88a3f);
}
</style>
